import type { UpsellProductData } from "@/lib/cart/upsell-product";

/**
 * Client side of `/api/cart/upsell-product`: `null` when the product is unavailable or the
 * request is rejected. Network and parse errors throw; callers already catch them.
 */
export async function fetchUpsellProduct(
	slug: string,
	channel: string,
	locale: string,
): Promise<UpsellProductData | null> {
	const query = new URLSearchParams({ slug, channel, locale });
	const response = await fetch(`/api/cart/upsell-product?${query.toString()}`);
	if (!response.ok) return null;
	return (await response.json()) as UpsellProductData | null;
}
